import {NextPublicationHelper} from 'Core/NextPublication/NextPublicationHelper';
import {NextPublicationModal} from 'Core/NextPublication/UI/NextPublicationModal';
import {NextPublicationBanner} from 'Core/NextPublication/UI/NextPublicationBanner';

export class NextPublicationController {
    private static _banner: NextPublicationBanner;
    private static _modalShown = false;

    static InitBanner(targetId: string) {
        if (!NextPublicationController._banner) {
            NextPublicationController._banner = new NextPublicationBanner();
            NextPublicationController._banner.Render(targetId);
        }
        NextPublicationController._banner.Refresh();
    }

    static ShowLoginModalIfNeeded() {
        if (NextPublicationController._modalShown) {
            return;
        }
        const value = NextPublicationHelper.GetRawValue();
        if (!NextPublicationHelper.IsWithinWindow(value)) {
            return;
        }
        NextPublicationController._modalShown = true;
        const displayDate = NextPublicationHelper.FormatForDisplay(value);
        new NextPublicationModal().Load(displayDate);
    }

    static HideBanner() {
        if (NextPublicationController._banner) {
            NextPublicationController._banner.Hide();
        }
    }

    static Reset() {
        NextPublicationController._modalShown = false;
        NextPublicationController.HideBanner();
    }
}
